import React from 'react';
import Form from 'react-bootstrap/Form';
import { Col, Container, Row, Button } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import { withRouter } from '../withRouter';
import ChemEdit from '../ChemEdit';
import { Link } from 'react-router-dom';

class Administrator extends ChemComponent {
	constructor(props) {
		super(props);
		
		this.state = {
			admin: {
				ID: ''
			},
			renderKey: 0
		}
	}	

	componentDidMount() {
		this.loadAdmin();
	}
	
	userIsAuthorized() {
		// if this is an admin
		if (('' + this.props.user.uid).startsWith('fas.admin.')) {
			// admin can only view their own profile
			var loggedInUser = +this.props.user.uid.substring(10);
			return (loggedInUser === +this.props.params.adminId);
		} else {
			return false;
		}
	}

	loadAdmin(event) {
		var self = this;

		this.ajax({
			type: 'post',
			url: this.getConfig().host + '/FAS/Search',
			data: { 
				__RequestVerificationToken: this.props.user.antiForgeryToken,
				entity: 'ADMIN',
				search: { Attribute: 'ID', Operator: '=', LongValue: this.props.params.adminId },
				pageNumber: -1,
				pageSize: -1
			}
		}).done(function (data) {
			if (data.Success) {
				if (data.Data.length === 1) {
					if (self.userIsAuthorized()) {
						var admin = data.Data[0];
							
						self.mergeStateWithArrays({
							admin: admin,
							renderKey: self.state.renderKey + 1
						}, () => {
							if (event && event.nativeEvent && event.nativeEvent.submitter) event.nativeEvent.submitter.blur();
						});
					} else {
						self.showAlert('Permissions Error', 'User not authorized');
					}
				} else {
					self.showAlert('Admin Error', 'Expected to find 1 admin for ID ' + 
						self.props.params.adminId + ' but found ' + data.Data.length);
				}
			} else {
				self.showAlert('Server Error', data.Message);
			}			
		}).fail(function (jqXHR, textStatus, errorThrown) {
			self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
		});
	}
		
	onChange(accessor, value) {
		var admin = this.copyObject(this.state.admin);
		this.setByAccessor(admin, accessor, value);
		if (accessor === 'ADMINLEVEL') {
			this.setByAccessor(admin, 'ROLE', this.getRoleFromAdminLevel(value));
		}
		
		this.setState({
			admin: admin,
			renderKey: this.state.renderKey + 1
		});
	}
	
	getRoleFromAdminLevel(adminLevel) {
		if (this.isNumeric(adminLevel)) {
			switch (+adminLevel) {
				case 1: return 'Web Admin';
				case 2: return 'Facility Manager';
				case 3:	return 'Faculty Support Admin';
				case 4:	return 'Research Administrator';
				case 5:	return 'Recharge Analyst';
				case 6:	return 'PI';
				default: return null;
			}
		}
		return null;
	}
	
	validateUser(event, columns, data) {
		if (!this.userIsAuthorized()) {
			return "User is not authorized.";
		} else {
			return this.validate(columns, data);
		}
	}

	onSubmit(event) {
		var self = this;
		var admin = this.copyObject(this.state.admin);

		this.ajax({
			type: 'post',
			url: this.getConfig().host + '/Home/Update',
			data: { 
				__RequestVerificationToken: this.props.user.antiForgeryToken,
				entity: 'FAS.ADMIN',
				data: admin
			}
		}).done(function (data) {
			if (data.Success) {
				self.props.parent.showConfirmation(() => {
					return (<>
						Admin <Link to={'/FAS/Administrators/' + self.props.params.adminId}>
							{self.props.params.adminId}
						</Link> updated.
					</>);
				});				
			} else {
				self.showAlert('Server Error', data.Message);
			}			
		}).fail(function (jqXHR, textStatus, errorThrown) {
			self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
		});
	}
	
	render() {		
		return (<>
			<Container fluid>
			  <Row>
			    <Col style={{ paddingTop: '20px', paddingBottom: '10px', border: '1px solid #ccc', backgroundColor: '#FEFEFE' }}>
				  <Container fluid>
					<Row>
					  <Col>
						<div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>
						  Administrator {this.state.admin.ID}
						</div>
					  </Col>
					</Row>
					<Row>
					  <Col style={{ paddingBottom: '10px' }}>
						<ChemEdit parent={this} user={this.props.user} columns={adminColumns} data={this.state.admin}
							onChange={(accessor, value) => this.onChange(accessor, value)} renderKey={this.state.renderKey}
							validate={(event, columns, data) => this.validateUser(event, columns, data)}
							onSubmit={(event) => this.onSubmit(event)}>
							<Form.Group as={Row}>
							  <Col style={{ borderTop: '1px solid #eee', paddingTop: '5px' }}>
								<Button id="save" variant="warning" type="submit" className="float-end">Save</Button>
							  </Col>
							</Form.Group>							
						</ChemEdit>
					  </Col>
					</Row>
				  </Container>
				</Col>
			  </Row>
			</Container>
		</>);
	}
}

const adminColumns = [
	{ Header: 'Lab', accessor: 'FACILITYID', type: 'select',
		options: [{ value: null, label: 'Select...' },{ value: 34, label: 'Microanalytical Facility' }]}, 
	{ Header: 'First Name', accessor: 'FIRSTNAME', maxlength: 45, required: true },
	{ Header: 'Last Name', accessor: 'LASTNAME', maxlength: 45, required: true },
	{ Header: 'Email', accessor: 'USERNAME', maxlength: 100, required: true },
	{ Header: 'Password', accessor: 'PASS', maxlength: 20, required: true },
	{ Header: 'Role', accessor: 'ADMINLEVEL', type: 'select',
		options: [
			{ value: null, label: 'Select...' },
			{ value: 1, label: 'Web Admin'},
			{ value: 2, label: 'Facility Manager'},
			{ value: 3, label: 'Faculty Support Admin'},
			{ value: 4, label: 'Research Administrator'},
			{ value: 5, label: 'Recharge Analyst'},
			{ value: 6, label: 'PI'}
	]}
];

export default withRouter(Administrator);
